/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2020/02/right-time-right-place-advertising/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2020/02/right-time-right-place-advertising/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2020/02/right-time-right-place-advertising/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Right Time, Right Place? - Measurecamp Melb 2020 Talk - Is right time, right place advertising all its cracked up to be? - Tribalism",
  date: "2020-02-13",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. In this blog, we take a look at Right Time, Right Place Advertising!",
  image: "/img/posts/2020-02-13-right-time/1.webp",
  url: "https://www.tribalism.com.au/blog-post/2020/02/right-time-right-place-advertising",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Is right time, right place advertising all its cracked up to be? - Measure Camp Melbourne 2020 - Tribalism"
        image="/img/posts/2020-02-13-right-time/1.webp"
        url="https://www.tribalism.com.au/blog-post/2020/02/right-time-right-place-advertising"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. In this blog we take a look at Right Time, Right Place Advertising !"

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2020-02-13-right-time/1.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Right Time, Right Place? - Measurecamp Melb 2020 Talk
              </h1>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>

      <Footer
        
      />
    </div>
  );
}
